import React from "react";
import { FormGroup, Col, Row, Container } from "react-bootstrap";
import { connect } from "react-redux";

import { Button } from "components";
import { URLS } from "globalConstants";

import styles from "./resetPasswordSuccess.module.scss";

class ResetPasswordSuccessPage extends React.Component {
	constructor(props) {
		super(props);
		if (!this.props.showResetPasswordSuccessPage) {
			this.props.history.push(URLS.login);
		}

		this.okClick = this.okClick.bind(this);
	}

	okClick() {
		this.props.history.push("/");
	}

	render() {
		return (
			<Container>
				<Row className={styles.login}>
					<Col
						className={styles.loginBlock + " align-self-center"}
						md={{ span: 8, offset: 2 }}
					>
						<Col md={{ span: 8, offset: 2 }}>
							<div className={styles.welcomBlock}>
								<span className={styles.messageBlock}>
									<h2>
										<b>Your new password is stored</b>
									</h2>
									<div>
										You can use it now to log into the
										system.
									</div>
								</span>
							</div>
							<FormGroup className="text-center">
								<Button
									onClick={this.okClick}
									className={styles.okBtn}
									value="OK"
								/>
							</FormGroup>
						</Col>
					</Col>
				</Row>
			</Container>
		);
	}
}

function mapStateToProps(state) {
	return {
		showResetPasswordSuccessPage: state.user.showResetPasswordSuccessPage,
	};
}

const connectedResetPasswordSuccessPage = connect(mapStateToProps)(
	ResetPasswordSuccessPage,
);
export { connectedResetPasswordSuccessPage as ResetPasswordSuccessPage };
